export const adminStatesConstants = {
  GET_ALL_STATES_REQUEST: "GET_ALL_STATES_REQUEST",
  GET_ALL_STATES_SUCCESS: "GET_ALL_STATES_SUCCESS",
  ADMIN_STATES_CLEAR: "ADMIN_STATES_CLEAR",

  GET_ALL_ZIPCODES_SUCCESS: "GET_ALL_ZIPCODES_SUCCESS"
};
